__turbopack_context__.v({
  "item": "DataFeedReadoutWidget-module__okT4sa__item",
  "readout": "DataFeedReadoutWidget-module__okT4sa__readout",
  "sep": "DataFeedReadoutWidget-module__okT4sa__sep",
});
